import { Box } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import img from "../../images/not-found.svg";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ height: "90vh" }} className="flex items-center justify-center">
      <Box sx={{ display: { sm: "flex" } }} className="items-center">
        <Box
          sx={{ width: { sm: "50%" } }}
          className="flex items-center justify-center"
        >
          <div>
            <h5 className="text-white">Page Doesn't Exist</h5>
            <button
              className="primary-btn mt-5 px-6 py-2 font-semibold rounded-full"
              onClick={() => navigate("/", { replace: true })}
            >
              Back to Home
            </button>
          </div>
        </Box>
        <Box
          sx={{ width: { sm: "50%" } }}
          className="flex justify-center"
        >
          <img src={img} alt="" className="w-2/3 mt-5" />
        </Box>
      </Box>
    </Box>
  );
};

export default NotFound;
